<template>
  <v-chip
    variant="flat"
    :class="getCellClass(isSuccess)"
  >
    {{ value }}
  </v-chip>
</template>

<script>
import api from '@/api';

export default {
  name: 'InfoDlg',
  props: {
    isSuccess: {
      type: Boolean,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    getCellClass(isSuccess) {
      if (isSuccess === null || isSuccess === undefined) {
        return 'unknown';
      }
      return isSuccess ? 'success' : 'failure';
    },
  },
};
</script>

<style scoped>
.unknown {
  color: rgb(var(--not-reviewed-dot-color));
  background-color: rgb(var(--grey-lighten-color));
  --circle-color: rgb(var(--not-reviewed-dot-color));
}

.success {
  color: rgb(var(--accepted-dot-color));
  background-color: rgb(var(--accepted-color));
  --circle-color: rgb(var(--accepted-dot-color));
}

.failure {
  color: rgb(var(--declined-dot-color));
  background-color: rgb(var(--declined-color));
  --circle-color: rgb(var(--declined-dot-color));
}

:deep(.v-chip__content) {
  font-size: 14px;
}

:deep(.v-chip__content::before) {
  display: block;
  content: '';
  background-color: var(--circle-color);
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 6px;
}
</style>